import React from 'react'
import { Updater, async, fromJSX, Widget } from 'widgets-for-react'
import { RelatedContentBlock } from '../../blocksState'
import { RelatedContentBlockLayout } from './relatedContentBlockLayout'
import { NewsOrEvent, RelatedContentBlockState } from './relatedContentBlockState'

export const relatedContentBlockWidget = (block: RelatedContentBlock): Widget<Updater<RelatedContentBlockState>> =>
  async<NewsOrEvent[]>(block.relatedContentBlockState, items =>
    fromJSX(() => (
      <RelatedContentBlockLayout
        index={block.index}
        items={items}
        readMoreNewsUrl={`/nieuws?${
          block.filter.source === 'department'
            ? `department=${block.filter.department}`
            : block.filter.source === 'specialist'
            ? `specialist=${block.filter.specialist}`
            : block.filter.tags.map((tag,index) => index == 0 ? `tags=${tag}` : `${tag}`).join('%2C')
        }`}
        readMoreAgendaUrl={`/agenda?${
          block.filter.source === 'department'
            ? `department=${block.filter.department}`
            : block.filter.source === 'specialist'
            ? `specialist=${block.filter.specialist}`
            : block.filter.tags.map((tag,index) => index == 0 ? `tags=${tag}` : `${tag}`).join('%2C')
        }`}
        pagination={false}
      />
    ))
  )
